import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { useAuth } from './AuthContext';

interface GoalsContextType {
  refreshGoals: () => Promise<void>;
  goalsUpdated: boolean;
}

const GoalsContext = createContext<GoalsContextType | undefined>(undefined);

export function GoalsProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [goalsUpdated, setGoalsUpdated] = useState(false);

  const refreshGoals = async () => {
    setGoalsUpdated(prev => !prev);
  };

  // Monitorar mudanças nas metas do usuário
  useEffect(() => {
    if (!user) return;

    const subscription = supabase
      .channel('goals-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'daily_goals',
          filter: `user_id=eq.${user.id}`
        },
        () => {
          refreshGoals();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [user]);

  return (
    <GoalsContext.Provider value={{ refreshGoals, goalsUpdated }}>
      {children}
    </GoalsContext.Provider>
  );
}

export function useGoals() {
  const context = useContext(GoalsContext);
  if (context === undefined) {
    throw new Error('useGoals must be used within a GoalsProvider');
  }
  return context;
}